import React, { useState } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import loadable from '@loadable/component'
import { Loader } from '../../../../common/components';

const UserList = loadable(() => import('./UserList'), {
    fallback: <Loader/>,
});
const AddUserPage = loadable(() => import('./AddUserPage'), {
    fallback: <Loader/>,
});
const EditUserPage = loadable(() => import('./EditUserPage'), {
    fallback: <Loader/>,
});
const ViewUser = loadable(() => import('./ViewUser'), {
    fallback: <Loader/>,
});
import UserAddressRoutes from './Address/UserAddressRoutes';
import UserContactRoutes from './Contact/UserContactRoutes';
import UserDepartmentAndDesignationRoutes from './DepartmentAndDesignation/UserDepartmentAndDesignationRoutes';
import UserSkillsScoreRoutes from './UserSkillsScore/UserSkillsScoreRoutes';
import UserApproverRoutes from './Approver/UserApproverRoutes';
import UserOtherRoutes from './Others/UserOtherRoutes';
import { UserNavigation } from './Navigation/UserNavigation';
import { useRouteAccessList } from '@hooks';

const UserRoutes = ({ t, alert }) => {
  const [routeName, setRouteNames] = useState([]);

  // Route Access List
  useRouteAccessList((res) => {
    setRouteNames(res.data.route_name);

  });

  return (
    <Routes key={'routes'}>
        <Route key={'user_list'} index exact path="/list" element={<UserList t={t} alert={alert} />} />
        <Route key={'user_add'} exact path="/add" element={<AddUserPage t={t} alert={alert} />} />
        <Route exact path="/edit/:id" element={<EditUserPage t={t} alert={alert} />} />
        <Route path='/' element={<UserNavigation t={t} routeName={routeName}/>}>
            <Route exact path="/view/details/:id" element={<ViewUser t={t} alert={alert} />} />
            <Route path="*" element={<Navigate replace to="/404" />} />
            {UserAddressRoutes({ t, alert })}
            {UserContactRoutes({ t, alert })}
            {UserDepartmentAndDesignationRoutes({ t, alert })}
            {UserSkillsScoreRoutes({ t })}
            {UserApproverRoutes({ t, alert })}
            {UserOtherRoutes({ t, alert })}
      </Route>
    </Routes>
  );
};
UserRoutes.propTypes = {
  t: PropTypes.func
};
export default UserRoutes;
